<template>
  <div class='col-12 col-lg-6 g c'>
    <br><br><br><br><br><br>
    <div class="card card-body" style="border-radius: 50px">
        <h1 class="text-center">
            <img :src="require('@/assets/videos/success.gif')">
            <br>
            تم الاشتراك في الاداة بنجاح!
            <br>
        </h1>
        <center>قم الان بفتح منصة مدرستي ويمكنك استخدام الاداة الان.</center>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>